<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between gap-3">
    <div>
      <h3 class="m-0 text-lg font-semibold">CapEx Equipment</h3>
      <p class="m-0 text-sm text-muted-color">
        Selected equipment and calculated equipment metrics for this item.
      </p>
    </div>
    @if (!readOnly && !editMode) {
      <p-button
        label="Edit"
        icon="pi pi-pencil"
        severity="secondary"
        (onClick)="startEdit()"
      />
    }
  </div>

  @if (editMode) {
    <div
      class="flex flex-col gap-3 rounded border border-surface-switch-200 bg-surface-switch-50 p-3"
    >
      <label class="text-sm font-semibold" for="capexEquipmentSelect">
        Select equipment
      </label>
      <p-multiSelect
        inputId="capexEquipmentSelect"
        [(ngModel)]="selectedEquipmentIds"
        [options]="equipmentOptions"
        optionLabel="name"
        optionValue="id"
        placeholder="Select CapEx equipment"
        display="chip"
        appendTo="body"
        [filter]="true"
        [showClear]="true"
      />
      <div class="flex justify-end gap-2">
        <p-button
          label="Cancel"
          severity="secondary"
          [disabled]="saving"
          (onClick)="cancelEdit()"
        />
        <p-button
          label="Save and Recalculate"
          icon="pi pi-refresh"
          [loading]="saving"
          (onClick)="save()"
        />
      </div>
    </div>
  }

  @if (selectedEquipmentLinks.length > 0) {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      @for (link of selectedEquipmentLinks; track link.equipment.id) {
        <div
          class="rounded border border-surface-switch-200 bg-surface-switch-0 p-3"
        >
          <div class="flex items-start justify-between gap-3 mb-3">
            <div>
              <div class="font-semibold text-surface-switch-900">
                {{ link.equipment.name }}
              </div>
              <div class="text-sm text-muted-color">
                {{ link.equipment.equipment_type }}
              </div>
            </div>
            @if (link.equipment.capex_cost) {
              <div class="font-semibold">
                {{ link.equipment.capex_cost | currency: currencyCode }}
              </div>
            }
          </div>

          <div class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <div class="text-muted-color">Shifts</div>
            <div class="text-right">{{ link.shifts }}</div>

            <div class="text-muted-color">Hours / shift</div>
            <div class="text-right">{{ link.hours_per_shift }}</div>

            <div class="text-muted-color">Days / year</div>
            <div class="text-right">{{ link.days_per_year }}</div>

            <div class="text-muted-color">Efficiency</div>
            <div class="text-right">
              {{ +link.equipment_efficiency * 100 | number: "1.0-2" }}%
            </div>

            <div class="text-muted-color">Availability</div>
            <div class="text-right">
              {{ link.equipment_availability_hours_per_year ?? "—" }}
              @if (link.equipment_availability_hours_per_year) {
                hrs/yr
              }
            </div>

            <div class="text-muted-color">Amortization</div>
            <div class="text-right">
              @if (link.amortization_per_hour) {
                {{ link.amortization_per_hour | currency: currencyCode }} / hr
              } @else {
                —
              }
            </div>

            <div class="text-muted-color">Run cost</div>
            <div class="text-right">
              @if (link.run_cost_per_hour) {
                {{ link.run_cost_per_hour | currency: currencyCode }} / hr
              } @else {
                —
              }
            </div>

            <div class="text-muted-color">Max parts / process</div>
            <div class="text-right">
              {{ link.equipment.max_parts_per_process ?? "—" }}
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div
      class="rounded border border-dashed border-surface-switch-300 bg-surface-switch-50 p-6 text-center text-muted-color"
    >
      No CapEx equipment selected for this item.
    </div>
  }
</div>
